"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopRestaurantsMap = void 0;
const React = require("react");
const SelectRestaurantMap_1 = require("../../../atoms/SelectRestaurantMap");
const restaurantCard_1 = require("../../../helpers/restaurantCard");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "DesktopRestaurantsMap");
const DesktopRestaurantsMap = ({ restaurants, selectRestaurant }) => (React.createElement("div", { className: css("desktopMap") },
    React.createElement(SelectRestaurantMap_1.SelectRestaurantMap, { restaurants: restaurants, mapId: "desktopMap", mapHeight: 400, onRestaurantMarkerClick: selectRestaurant, onRestaurantMarkerHover: restaurantCard_1.hoverRestaurantCard, onRestaurantMarkerLeave: restaurantCard_1.unhoverRestaurantCard })));
exports.DesktopRestaurantsMap = DesktopRestaurantsMap;
//# sourceMappingURL=index.js.map